export default __webpack_public_path__ + "static/media/time.563d3407.svg";